import type { ReactNode } from 'react'

/**
 * One viewport-tall column: a page-wide notice (the platform-status banner) first, at its own height,
 * then `children` in the rest. For full-height screens that own their scrolling, such as the shell-less
 * onboarding wizard (`OnboardingLayout` fills its parent): the banner takes its share of the viewport
 * instead of pushing the screen's footer and sidebar sign-out below the fold. With no banner the region
 * is the whole viewport, exactly as before.
 *
 * `transform-gpu` makes the region the containing block of `position: fixed` descendants (the wizard's
 * mobile header), so they sit under the banner rather than over it. Portalled overlays (sheets, dialogs)
 * render outside the region and are unaffected.
 */
export function ViewportWithBanner({ banner, children }: { banner: ReactNode; children: ReactNode }) {
  return (
    <div className="flex h-screen flex-col overflow-hidden">
      {banner}
      <div className="relative min-h-0 flex-1 transform-gpu">{children}</div>
    </div>
  )
}
